import { Chart as ChartJS } from 'chart.js'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { getUniqueKey } from '../../../../utils/HTMLutils'
import { languageValues } from '../../../../utils/LanguageUtils'
import { numberToMoeda } from '../../../../utils/MoedaUtils'

export default function MoneyMonthLineChart(props) {
  const [id] = useState(`canvas${getUniqueKey()}`)

  useEffect(() => {
    const chart = document.getElementById(id)
    var ctx = chart.getContext('2d')
    var gradient = ctx.createLinearGradient(0, 0, 0, 500)
    gradient.addColorStop(0, '#d7e6c8')
    gradient.addColorStop(0.3, '#d7e6c8')
    gradient.addColorStop(0.5, '#FFFFFF00')
    gradient.addColorStop(1, 'rgba(0,0,0,0)')
    const min = Math.min(...props.data)
    const max = Math.max(...props.data)
    const diff = max - min
    const limiteSuperior = diff < 10 && diff / 2 > 10 ? max + 5 : max + diff / 2
    const limiteInferior = diff < 10 && diff / 2 > 10 ? min - 3 : min - diff / 2

    const data = {
      labels: props.labels,
      datasets: [
        {
          // label: 'Custom Label Name',
          backgroundColor: gradient,
          pointBackgroundColor: 'rgba(0, 0, 0, 0)',
          pointBorderWidth: 0.1,
          pointHitRadius: 28,
          pointBorderColor: '#3fa110',
          pointHoverBorderWidth: 8,
          borderWidth: 2.5,
          borderColor: '#3fa110',
          data: props.data
        }
      ]
    }
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      // animation: {
      //   easing: 'easeInOutQuad',
      //   duration: 520
      // },
      scales: {
        xAxes: [
          {
            display: true,
            gridLines: {
              display: false,
              color: 'rgba(0, 0, 0, 0)',
              lineWidth: 0
            },
            ticks: {
              fontColor: '#3fa110',
              fontSize: 16,
              fontStyle: '700',
              fontFamily: 'Nunito',
              lineHeight: '24px',
              callback: (value, index, values) => {
                return languageValues.months[value]
                  ? languageValues.months[value].short
                  : ''
              }
            }
          }
        ],
        yAxes: [
          {
            display: false,
            ticks: {
              fontColor: '#3fa110',
              fontSize: 16,
              fontStyle: '700',
              fontFamily: 'Nunito',
              lineHeight: '24px',
              suggestedMin: limiteInferior,
              suggestedMax: limiteSuperior
            },
            gridLines: {
              display: false,
              color: 'rgba(0, 0, 0, 0)',
              lineWidth: 0
            }
          }
        ]
      },
      elements: {
        line: {
          tension: 0.4
        }
      },
      legend: {
        display: false
      },
      tooltips: {
        bodyFontFamily: '"Nunito", sans-serif',
        bodyFontSize: 16,
        bodyAlign: 'center',
        xPadding: 30,
        yPadding: 10,
        custom: (tooltip) => {
          if (!tooltip) return
          tooltip.displayColors = false
          tooltip._bodyAlign = 'center'
        },
        callbacks: {
          title: (tooltipItem, data) => {
            return ''
          },
          label: (tooltipItem, data) => {
            return numberToMoeda(tooltipItem.value)
          }
        }
      }
    }

    // eslint-disable-next-line no-new
    new ChartJS(chart, {
      type: 'line',
      data,
      options
    })
  }, [id, props.data, props.labels])

  return <canvas id={id} />
}

MoneyMonthLineChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number),
  labels: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )
}

MoneyMonthLineChart.defaultProps = {
  data: [],
  labels: [
    'jan',
    'fev',
    'mar',
    'abr',
    'mai',
    'jun',
    'jul',
    'ago',
    'set',
    'out',
    'nov',
    'dez'
  ]
}
